import { TileLayer } from "react-leaflet";

import { useBackgroundIndicator } from "../../hooks/indicatorHooks";
import { Indicator } from "../../types";

interface Props {
  backgroundIndicators: Indicator[];
}

export const BackgroundLayer = (props: Props) => {
  const { backgroundIndicators } = props;
  const [currentBackgroundLayer] = useBackgroundIndicator(backgroundIndicators);
  const [wmsLayer] = currentBackgroundLayer?.layers || [];


  return (
    <>
      {currentBackgroundLayer && wmsLayer && (
        <TileLayer
          key={currentBackgroundLayer.id}
          {...wmsLayer.wms}
          // start at default tilePane index: 200 https://leafletjs.com/reference.html#map-mappane
          zIndex={200}
        />
      )}
      {(!currentBackgroundLayer || !wmsLayer) && (
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright" rel="noopener noreferrer" target="_blank">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          zIndex={0}
        />
      )}
    </>
  );
};
